function workRange(row) {
    const dates = row.available ? (row.entries || []).filter(entry => Number(entry.worked_minutes) > 0)
        .map(entry => String(entry.work_date || '').slice(0, 10)).filter(date => /^\d{4}-\d{2}-\d{2}$/.test(date)).sort() : [];
    return {first: dates[0] || null, last: dates[dates.length - 1] || null};
}
const natural = (a, b) => String(a || '').localeCompare(String(b || ''), 'ru', {numeric: true});
function orderedRows(rows, order = 'work') {
    const groups = new Map();
    rows.forEach(row => {
        const id = Number(row.building_id) || 0;
        if (!groups.has(id)) groups.set(id, {id, name: row.object_name, rows: [], first: null, available: false});
        const group = groups.get(id), range = workRange(row);
        group.rows.push({row, range}); group.available = group.available || row.available;
        if (range.first && (!group.first || range.first < group.first)) group.first = range.first;
    });
    const rank = value => value.first ? 0 : value.available ? 1 : 2;
    return Array.from(groups.values()).sort((a, b) => rank(a) - rank(b)
        || (order === 'work' ? natural(a.first, b.first) : 0) || natural(a.name, b.name) || a.id - b.id)
        .flatMap(group => group.rows.sort((a, b) => rank({...a.range, available: a.row.available}) - rank({...b.range, available: b.row.available})
            || natural(a.range.first, b.range.first) || natural(a.row.timesheet_name, b.row.timesheet_name) || natural(a.row.id, b.row.id)).map(item => item.row));
}
module.exports = {workRange, orderedRows};
